import React from 'react'
import { PropTypes } from 'prop-types'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

const getTitle = (title, type) => {
  if (!!title) {
    return title
  } else {
    switch (type) {
      case 'error':
        return 'Accidenti'
      case 'warning':
        return 'Attenzione'
      case 'success':
        return 'Benissimo'
      case 'info':
        return 'Info'
    }
  }
}

const Result = props => (
  <div {...css(props.styles.result, props.styles[`result--${props.type}`])}>
    <span {...css(props.styles.title)}>
      {getTitle(props.title, props.type)}
    </span>
    <div {...css(props.styles.message)}>{props.children}</div>
  </div>
)

Result.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string,
  styles: PropTypes.object.isRequired
}

export default withStyles(Styles)(Result)



// WEBPACK FOOTER //
// ./components/result/index.js